import anime from 'animejs';

export default class {

    constructor({
        container, // Main slider container
        mobile = false
    } = {}) {

        this.container = document.querySelector(container);
        this.mobile = mobile;
        this.slide = false;
        this.totalAnimationDuration = 0;

        // is the element present on the current page
        if (! this.container) {
            return;
        }

        // Gather all slides and switchers
        this.slides = [...this.container.querySelectorAll('.slider__item')];
        this.switchers = [...this.container.querySelectorAll('.slider__switcher')];

        // An array containing the switcher button animations, for easier control
        this.switchersAnimations = [];

        // Calculate slider spacing based on CSS values
        this.slider_spacing = getComputedStyle(this.container.querySelector('.slider__slides')).getPropertyValue('top');
        this.slider_spacing = parseInt(this.slider_spacing) / 2;

        this.setThirdSwitcherPosition();

        // Main slider animation timeline
        this.animation = anime.timeline({
            easing: 'easeOutCubic',
            loop: true
        });

        // Switchers animation timeline
        this.switchAnimation = anime.timeline({
            easing: 'easeOutCubic',
            loop: true
        });

        // We start the resize handler, as a passive listerner
        this._resizeTimer = null;
        window.addEventListener('scroll', this, { passive: true });
        window.addEventListener('resize', this, { passive: true });

        this.container.addEventListener('mouseenter', this, { passive: true });
        this.container.addEventListener('mouseleave', this, { passive: true });

        this.checkIfAnimationShouldRun();
    }

    handleEvent(e) {
        switch (e.type) {
            case 'resize':
                this.resizeHandler(e);
                break;
			case 'scroll':
				this.animation.pause();
                this.switchersAnimations.forEach(item => {
                    item.pause();
                })
				this.animation.play();
                this.switchersAnimations.forEach(item => {
                    item.play();
                })
				break;
            case 'mouseenter':
                this.animation.pause();
                this.switchersAnimations.forEach(item => {
                    item.pause();
                })
                break
            case 'mouseleave':
                this.animation.play();
                this.switchersAnimations.forEach(item => {
                    item.play();
                })
                break
        }
    }

    /**
     * The resize handler starts/stops the slider on resize if neccessary
     * It triggers max 100ms aftter we stop resizing the window
     */
    resizeHandler(e) {
        clearTimeout(this._resizeTimer);

        this._resizeTimer = setTimeout(_ => {
            this.checkIfAnimationShouldRun();
            this.setThirdSwitcherPosition();
            this._resizeTimer = null;
        }, 100);
    }

    /**
     * Do we run the animation?
     * 767px is the mobile breakpoint
     */
    checkIfAnimationShouldRun() {
        if (window.screen.width < 767 & !this.mobile) {
            this.stop()
        } else {
            this.start();
        }
    }

    /**
     * Calculate the current slide item width dimension
     * Based on spacing and index.
     */
    dimension(index) {
        return this.container.clientWidth - (this.slider_spacing * 2 * (3 - index));
    }

    /**
     * Start the animation
     */
    start() {
        this.prepareAnimation();
        this.prepareSwitchAnimation();

        // this.animation.play();
        // this.switchAnimation.play();
    }

    /**
     * Stop the animation
     */
    stop() {
        if (this.animation) {
            this.animation.pause();
        }

        if (this.switchAnimation) {
            this.switchAnimation.pause();
        }
    }

    /**
     * If we have a third switch, we need to position it correctly
     */
    setThirdSwitcherPosition() {
        let thirdSwitcher = this.container.querySelector('.slider__switcher-3');
        if (thirdSwitcher) {
            thirdSwitcher.style.left = (0 - thirdSwitcher.offsetWidth - 17) + 'px';
        }
    }

    /**
     * Based on the screen width we select a different path
     * xl 1440px+
     * lg 992px - 1440px
     * sm 0 - 992px
     */
    selectSwitcherPath() {
        if (window.innerWidth >= 1440) {
            return 'xl';
        } else if (window.innerWidth < 1440 && window.innerWidth >= 768) {
            return 'lg';
        } else {
            return 'sm';
        }
    }

    prepareSwitchAnimation() {
        let switcherAnimationDuration = 15000;
        let slideSwitcherItemSelector = '.slider__switcher-';
        let svgSegmentSelector = '.slider__segment-' + this.selectSwitcherPath() + '-' ;

        for (let index = 0; index < this.switchers.length; index++) {
            let element = this.switchers[index];
            let path = anime.path(svgSegmentSelector + (index + 1));
            let next_index = index + 1

            // delay animation randomly
            let delay = Math.floor(Math.random() * 5000);

            if (this.switchers.length == next_index) {
                next_index = 0;
            }

			// hide switcher if empty text
			if (!this.switchers[index].innerHTML)  {
				this.switchers[index].style.display = 'none';
			}
			
            this.switchersAnimations.push(anime({
                targets: slideSwitcherItemSelector + (index + 1),
                translateX: path('x'),
                translateY: path('y'),
                direction: 'alternate',
                delay: delay,
                rotate: 0,
                easing: 'easeInOutSine',
                duration: switcherAnimationDuration,
                loop: true
            }));

            element.addEventListener('click', (event) => {
                this.animation.pause();
                this.animation.seek(this.totalAnimationDuration * index - 250);
                this.switchers.forEach(el => {
                    el.classList.remove('active');
                });
                this.animation.play();
            });
        }
    }

    prepareAnimation() {
        // CSS Selectors
        let slidesSelector = '.slider__slides';
        let sliderSvgSelector = '.slider__slides svg';
        let slideItemSelector = '.slider__item.slider__item-'
        let sliderFillSelector = '.slider__fill';
        let slideItemTextSelector = '.slider__text-';
        let slideSwitcherItemSelector = '.slider__switcher-';

        // Animation durations
        let sliderAnimationDuration = 7500; // Main animation duration in ms
        let slideFadeDuration = 1000;
        let slideFadeOffset = 250; // We start the fade before the previous animation ends
        this.totalAnimationDuration = sliderAnimationDuration + (slideFadeDuration - slideFadeOffset);

        // Loop through the slides
        for (let index = 0; index < this.slides.length; index++) {
            // index1 starts with 1
            let index1 = index + 1;
            let previous_index = ((index1 - 1) < 1) ? this.slides.length : index1 - 1;

            // Calculate the width & height
            var d = this.dimension(index1);
			// if marked as singlesize, show all slides in same size
			if (this.container.querySelector(slidesSelector).closest(".singlesize")) {
				d = this.dimension(1);
			}

            this.animation
            .add({
                // After the slider finishes the fill, we remove the fill from the edge
                // We start a bit sooner than the slider timeline finishes
                targets: sliderSvgSelector,
                opacity: 0,
                duration: 250,
            }, '-=250')
            .add({
                // Empty the gradient fill
                targets: sliderFillSelector,
                strokeDashoffset: function (el) {
                    return [0, el.getAttribute('stroke-dasharray')]
                },
                duration: 50,
            })
            .add({
                // Fade out the current slide
                targets: slideItemSelector + previous_index,
                opacity: 0,
                duration: slideFadeDuration,
                changeBegin: anim => {
                    this.removeClass(this.container.querySelector(slideSwitcherItemSelector + previous_index), 'active')
                    this.addClass(this.container.querySelector(slideSwitcherItemSelector + index1), 'active')
                },
            }, '-=250')
            .add({
                // Fade out the current text slide
                targets: slideItemTextSelector + previous_index,
                opacity: 0,
				zIndex: 10,
                translateY: '-110px',
                duration: slideFadeDuration,
                easing: 'easeOutQuad',
            }, '-=' + slideFadeDuration)
            .add({
                // We change the slides dimension for the next stage
                targets: slidesSelector,
                height: d + "px",
                width: d + "px",
                top: ((this.container.clientWidth - d) / 2) + "px",
                left: ((this.container.clientWidth - d) / 2) + "px",
                duration: slideFadeDuration,
            }, '-=' + (slideFadeDuration))
            .add({
                // Fade in the next slide
                targets: slideItemSelector + index1,
                opacity: 1,
                duration: slideFadeDuration,
            }, '-=' + (slideFadeDuration))
            .add({
                // Fade in the next text slide
                targets: slideItemTextSelector + index1,
                opacity: 1,
				zIndex: 20,
                translateY: ['-110px', 0],
                duration: slideFadeDuration,
                easing: 'easeOutQuad',
            }, '-=' + (slideFadeDuration))
            .add({
                // We start fading the slider fill bar back in
                targets: sliderSvgSelector,
                opacity: 1,
                duration: 250,
            }, '-=' + (slideFadeOffset))
            .add({
                // Main slider time animation (orange gradient fill)
                targets: sliderFillSelector,
                strokeDashoffset: function (el) {
                    return [el.getAttribute('stroke-dasharray'), 0]
                },
                duration: sliderAnimationDuration,
            });
        }
    }

    /**
     * Helper to remove class from element.
     * Removes only if class exists
     */
    removeClass(el, className) {
        if (el.classList.contains(className)) {
            el.classList.remove(className);
        }
    }

    /**
     * Helper to adding class to element.
     */
    addClass(el, className) {
        if (el) {
            el.classList.add(className);
        }
    }
}